import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IAPP_CONFIG } from "@app/constants";
import { caller } from "@app/services/apiServices/utils/trace-debug-tools";
import { WindowToken } from "@app/util/window.token";
import { AppDataService } from "@app/services/appData.service";

class CheckError extends Error { }

@Injectable()
export class HOAApiBase {

    appConfig: IAPP_CONFIG;
    http: HttpClient;
    appDataService: AppDataService
    window;

    private readonly DEBUG = false

    protected debug: typeof console.log = this.DEBUG ?
        console.log.bind(console, "%cHOAApiBase", 'color: hotpink; font-weight: bold;') :
        function () { }

    constructor(protected base: string) {

        this.http = inject(HttpClient);
        this.appDataService = inject(AppDataService);
        this.window = inject(WindowToken);

        if (this.debug) this.debug =
            console.debug.bind(console, `%c[DEBUG] HOAApiBase/${this.base}`, 'color: blue; font-weight: bold')

    }

    public getBasePath() {
        return "hoa-gateway"
    }

    public getLocalPath() {
        return "HOAPass"
    }

    public getDigitalPaymentPath() {
        return "digital-payment"
    }

    createUrl(to: string, endpoint: string): string {
        const serviceURL = this.getServiceUrl(to);
        let url = `${serviceURL.replace(/\/$/, '')}/${endpoint.replace(/^\//, '')}`
        return url.replace(new URL(url).origin, '');
    }

    protected check<T>(obj: { [name: string]: T }, label = 'truthy', is: (v: T) => any = v => v): void {
        const callerName = caller()
        const errors = Object.keys(obj).map(key => {
            const value = obj[key]
            if (!is(value)) return `'${key}' (${JSON.stringify(value)}) passed to '${callerName}' is not '${label}'`
        }).filter(errorMessage => !!errorMessage)
        if (errors.length > 0) {
            this.debug(`${callerName} calling check() caught errors: ${errors.join('\n')}`)
            throw new CheckError(errors.join('\n'))
        }
    }

    private getServiceUrl(to: string): string {

        let serviceUrl: string;

        switch (to) {
            case "hoa-gateway":
                serviceUrl = this.appDataService.appConfig.get_APP_ENV().HOA_GATEWAY_URL;
                break;
            case "HOAPass":
                serviceUrl = this.appDataService.appConfig.get_APP_ENV().HOAPASS_API_URL;
                break;
            case "digital-payment":
                serviceUrl = this.appDataService.appConfig.get_APP_ENV().DIGITAL_PAYMENT_URL;
                break
        }

        return serviceUrl;
    }
}
